import {
  Box,
  IconBolt,
  Chip,
  IconDone,
  Typography,
  Button,
  theme,
} from '@capitalise/ui-design-system';
import { createDataTestId } from '@capitalise/utils';
import IncompleteApplicationSVG from 'assets/svgs/incomplete-application.svg';

const BoxBenefit = ({ title, description }: { title: string; description: string }) => (
  <Box display="flex" flexDirection="column">
    <Box flexPosition="center center" gap="tiny">
      <IconDone color="green" />
      <Typography size="heading-18" color="grey-900">
        {title}
      </Typography>
    </Box>
    <Typography size="body-16" color="grey-700" textAlign="center">
      {description}
    </Typography>
  </Box>
);

const benefits = [
  { title: 'Easy to complete', description: 'Complete your application in under 6 minutes.' },
  { title: 'Dedicated support', description: 'Assistance from our funding specialists.' },
  { title: '+100 lenders', description: 'Compare offers from multiple lenders.' },
];

const IncompleteDriver = ({
  hasIntantOffers,
  onClick,
}: {
  hasIntantOffers: boolean;
  onClick: () => null;
}) => {
  return (
    <>
      <Box
        flexPosition="center center"
        flexDirection="column"
        gap={{ _: 'xsmall', md: 'small' }}
        width="100%"
        padding={{ _: 'small', md: 'medium' }}
        borderRadius={theme.sizes['3xsmall']}
        backgroundColor="white"
        mt={{ _: 'large', md: '2xlarge' }}
        {...createDataTestId('box', 'incomplete-application')}
      >
        <IncompleteApplicationSVG />
        <Typography size="heading-22" color="grey-900" textAlign="center">
          Complete your application to apply and receive offers from lenders.
        </Typography>
        <Button baseColor="green" onClick={onClick}>
          Complete application
        </Button>
        <Box
          flexPosition="between center"
          flexDirection={{ _: 'column', md: 'row' }}
          gap={{ _: 'xsmall', md: 'medium' }}
          mt={{ _: 0, md: 'tiny' }}
          mb={{ _: 0, md: 'small' }}
        >
          {benefits.map((props) => (
            // eslint-disable-next-line react/prop-types
            <BoxBenefit key={props.title} {...props} />
          ))}
        </Box>
      </Box>
      {hasIntantOffers && (
        <Box
          flexPosition="start center"
          paddingBottom={{ _: '2xsmall', md: 'medium' }}
          paddingTop={{ _: '3xsmall', md: 'medium' }}
          paddingX={{ _: 'xsmall', md: 'medium' }}
          gap="2xsmall"
          borderRadius={theme.sizes['3xsmall']}
          backgroundColor="blue-50"
          mt="3xsmall"
          flexDirection={{ _: 'column', md: 'row' }}
          {...createDataTestId('box', 'instant-offers')}
        >
          <Chip size="small" baseColor="blue" round variant="filled" leftIcon={<IconBolt />}>
            <Typography size="caption-12" color="white">
              Instant offer
            </Typography>
          </Chip>
          <Box flexPosition="center start" flexDirection="column" gap="4xsmall">
            <Typography size="heading-16" color="grey-900" textAlign={{ _: 'center', md: 'left' }}>
              Your application is eligible for instant offers
            </Typography>
            <Typography size="body-14" color="grey-700" textAlign={{ _: 'center', md: 'left' }}>
              Your funding criteria matches an instant offer lender meaning you’ll get a response
              from this lender in less than 24 hours.
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

export default IncompleteDriver;
